export type OnSuccess = () => void;
export type OnFailure = () => void;
export type OnSuccessData<T> = (data: T) => void;
export type OnFailureData<T> = (data: T) => void;
export interface ValidationErrors {
    email?: string | string[];
    password?: string | string[];
}
export const instanceOfValidationError = (errors: any): errors is ValidationErrors => {
    let isValidationError = true;
    if (!errors) {
        return false;
    }
    if (typeof errors !== 'object') {
        return false;
    }

    if (Object.keys(errors).length === 0) {
        return false;
    }

    Object.entries(errors).forEach(([key, message]) => {
        if (key !== 'email' && key !== 'password') {
            isValidationError = false;
            return;
        }
        if (!message) {
            return;
        }
        if (!(message instanceof Array) && typeof message !== 'string') {
            isValidationError = false;
            return;
        }
        if (message instanceof Array) {
            message.forEach(msg => {
                if (typeof msg !== 'string') {
                    isValidationError = false;
                }
            });
        }
    });

    return isValidationError;
};
